<template>
  <div v-if="isVisible" class="modal-backdrops">
    <div class="modal-container">
      <div class="modal-headers">
        <span v-html="title"></span>
      </div>
      <div class="modal-footers">
        <button @click="closeModal" class="btn btn-primary">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Error",
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
      // window.location.reload();
    },
  },
};
</script>

<style>
.modal-backdrops {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  .modal-container {
    background: white;
    border-radius: 8px;
    padding: 20px;
    width: 400px;
    max-width: 90%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
}

.modal-headers {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


.modal-footers {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;

}
</style>
